import splitDateParts from '../../helpers/split-date-parts';

/**
 * @param {Number} numberYears - number of years
 * @returns {Date}
 */
function buildDateBack(numberYears) {
  const [years, fraction] = numberYears.toString().split('.');
  const date = new Date();
  date.setFullYear(date.getFullYear() - years);
  const month = (fraction || 0) * 12 / 10;
  date.setMonth(date.getMonth() - month);

  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

/**
 * @public
 * Validates the date of birth based on the maximum and minimum age parameters.
 *
 * @param  {Object} config: configuration of the rule
 * @return {Object} indicates the validness of the field
 */
export default function dob({field, value, message, parameters, error}) {
  let dateNow = new Date();
  dateNow = new Date(dateNow.getFullYear(), dateNow.getMonth(), dateNow.getDate());
  const {month, day, year} = splitDateParts(value);
  const date = new Date(year, month - 1, day);

  if (date.getFullYear() > dateNow.getFullYear()) {
    return {
      field,
      isValid: false,
      message,
    };
  }

  if (typeof parameters['dob-max'] !== 'undefined') {
    const maxDate = buildDateBack(parameters['dob-max']);
    if (date <= maxDate) {
      return {
        field,
        isValid: false,
        message: {
          title: parameters['dob-title'] || parameters['dob-max-title'] || message.title,
          content: parameters['dob-content'] || parameters['dob-max-content'] || message.content,
        },
        errorHandler: typeof error === 'undefined' ? null : error['dob-max'],
      };
    }
  }

  if (typeof parameters['dob-min'] !== 'undefined') {
    const minDate = buildDateBack(parameters['dob-min']);
    if (minDate < date) {
      return {
        field,
        isValid: false,
        message: {
          title: parameters['dob-title'] || parameters['dob-min-title'] || message.title,
          content: parameters['dob-content'] || parameters['dob-min-content'] || message.content,
        },
        errorHandler: typeof error === 'undefined' ? null : error['dob-min'],
      };
    }
  }

  return {
    field,
    isValid: true,
  };
}
